import React from 'react';
import { fireLogEvent, TncInline } from '@chegg/commerce-utils';
import { tncStringManipulation } from '../../../utils/TncStringManipulation';
import { TncWrapper } from '../styled';
var TnC = function TnC(_ref) {
  var price = _ref.price,
    namespace = _ref.namespace,
    onError = _ref.onError,
    isOpen = _ref.isOpen,
    setShowOnlyTnc = _ref.setShowOnlyTnc,
    termsAndConditions = _ref.termsAndConditions,
    ctaLabel = _ref.ctaLabel,
    billingCycleContentKey = _ref.billingCycleContentKey,
    isCouponApplied = _ref.isCouponApplied,
    priceWithDiscount = _ref.priceWithDiscount;
  var formattedTermsContent = tncStringManipulation(termsAndConditions.content.json, price);
  return /*#__PURE__*/React.createElement(TncWrapper, {
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement(TncInline, {
    onError: onError,
    content: termsAndConditions,
    onRioEventFired: fireLogEvent,
    price: price,
    namespace: namespace,
    isOpen: isOpen,
    isOpenCallback: setShowOnlyTnc,
    formattedTermsContent: formattedTermsContent,
    ctaLabel: ctaLabel,
    billingCycleContentKey: billingCycleContentKey,
    isCouponApplied: isCouponApplied,
    priceWithDiscount: priceWithDiscount
  }));
};
export default TnC;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/TnC.js
// module id = 1465
// module chunks = 11